<template>
  <div>
    <v-snackbar v-model="showError" color="error">
      {{ this.errorText }}
    </v-snackbar>
    <h1 class="my-10">{{$t('app_info.title')}}</h1>
    <v-img :src="images.inkdrops" dark max-height="700px" contain>
    <v-card elevation="10" outlined dark class="mx-auto" min-width="300px" max-width="50%"
      :loading="loggingIn">
      <v-img :src="images.starry_night" dark max-height="500px"
        gradient="to right, rgba(00,00,00,.9), rgba(25,32,72,.80)">
        <v-card-title class="mx-2 my-5 justify-center"> {{ $t('login_form.login') }} </v-card-title>
        <v-card-text>
          {{ linkLoginText }}
        </v-card-text>
      </v-img>
    </v-card>
    </v-img>
  </div>
</template>
<script>
import i18n from '@/plugins/i18n'

export default {
  name: 'Login',
  data: () => ({
    loggingIn: true,
    showError: false,
    errorText: '',
    linkLoginText: 'Probíhá přihlašování přes partnerský odkaz. Prosím vyčkejte...',
    images: {
      starry_night: require('../../assets/starry_night.jpg'),
      inkdrops: require('../../assets/inkdrops.png')
    }
  }),
  computed: {
    hasAnyCollection () {
      return this.$store.getters['basicUserInfo/hasAnyCollection']
    }
  },
  mounted () {
    const code = this.$route.params.code
    const link = this.$route.params.link

    if (!code || !link) {
      // todo: show error
      this.showError = true
    }
    this.login(code, link)
  },
  methods: {
    async login (code, link) {
      var loginResult = false
      this.loggingIn = true
      await this.$store.dispatch('authentication/loginLink', { code: code, link: link })
        .then(result => {
          loginResult = true
        },
        error => {
          this.loggingIn = false
          if (error.response.status === 401) {
            // todo: better error code
            this.linkLoginText = 'Tento odkaz již není platný.'
            this.errorText = i18n.t('Tento odkaz již není platný.')
          } else {
            this.errorText = i18n.t('login_form.general_error')
          }
          this.showError = true
        })
      if (!loginResult) {
        this.loggingIn = false
        return
      }
      this.loginResult = false
      await this.$store.dispatch('basicUserInfo/refreshBasicUserInfo').then(result => {
        if (!this.hasAnyCollection) {
          this.errorText = i18n.t('login_form.no_collection_available')
          this.showError = true
          this.$store.dispatch('authentication/logout')
        }
        this.loginResult = true
      }, _ => {
        this.loggingIn = false
        this.errorText = i18n.t('login_form.refresh_user_data_error')
        this.showError = true
        this.$store.dispatch('authentication/logout')
      })
      if (!loginResult) {
        this.loggingIn = false
        this.$refs.passwordForm.focus()
        return
      }
      await this.$store.dispatch('collectionContext/refreshCollections').then(result => {
        this.loggingIn = false
        this.$router.push('/')
      }, _ => {
        this.loggingIn = false
        this.errorText = i18n.t('login_form.refresh_user_data_error')
        this.showError = true
        this.$store.dispatch('authentication/logout')
        this.$refs.passwordForm.focus()
      })
    }
  }
}
</script>

  <style>
  h1 {
    font-family: "Oxygen", monospace;
    color: black;
  }
  </style>



// WEBPACK FOOTER //
// src/components/users/LinkLogin.vue